import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { map } from 'lodash';
import moment from 'moment';

const TooltipWrapper = styled.div`
  display: table;
  table-layout: fixed;
  overflow: hidden;
  min-width: 256px;
  padding: 8px;
  background-color: white;
  opacity: 0.95;
  border: thin solid ${props => props.theme.borderColor};
`;

const TooltipLine = styled.div`
  display: table-row;
  width: 100%;
`;

const TooltipCell = styled.div`
  display: table-cell;
  empty-cells: show;
`;

const ChartTooltip = ({ data }) => (
  <TooltipWrapper>
    {map(data, item => (
      <TooltipLine>
        <TooltipCell>{item.label}</TooltipCell>
        <TooltipCell>{item.value}</TooltipCell>
      </TooltipLine>
    ))}
  </TooltipWrapper>
);

ChartTooltip.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ChartTooltip;
